import { IconCalendar, IconChevronLeft, IconChevronRight, IconRefresh, IconSearch } from '@tabler/icons-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailBarangPenjualan from './DetailBarangPenjualan';
import { IconReload } from '@tabler/icons-react';
import useKarat from '../features/useKarat';

const TrxPenjualan = () => {
  const navigate = useNavigate();
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  const [trxPenjualan, setTrxPenjualan] = useState([]);
  const [openLoading, setOpenLoading] = useState(false);
  const [detailPenjualan, setDetailPenjualan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);
  const [idKategori, setIdKategori] = useState(0);
  const [kategori, setKategori] = useState([]);

  const [openCalender, setOpenCalender] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  // const [totalHargaPenjualan, setTotalHargaPenjualan] = useState(0);
  // const [totalHargaFilter, setTotalHargaFilter] = useState(0);

  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const [isRefund, setIsRefund] = useState(0);

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState('');

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    async function getTrxPenjualan() {
      setLoading(true);
      await http
        .get(
          `penjualan${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${(idCabang === 0 || idCabang === '') ? `` : `&cabang=${idCabang}`}
          ${(selectedKategori === 0 || selectedKategori === '') ? `` : `&kategori=${selectedKategori}`}${(selectJenisKategori === 0 || selectJenisKategori === '') ? `` : `&jenis_kategori=${selectJenisKategori}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
          }${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}${isRefund === '' ? '&is_refund=0' : `&is_refund=${isRefund}`}`,
          {
            headers: { Authorization: getAuthorizationHeader() },
          },
        )
        .then((res) => {
          setTrxPenjualan(res.data.data.data);
          setCurrentPage(res.data.data.current_page);
          setItemsPerPage(res.data.data.per_page);
          setLastPage(res.data.data.last_page);
          return res.data.data;
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
      setLoading(false);
    }
    getTrxPenjualan();
  }, [
    idCabang,
    // idKategori,
    search.length >= 12 ? search : '',
    awal,
    akhir,
    startDate,
    endDate,
    currentPage,
    navigate,
    karatOptionId,
    berat,
    selectedKategori,
    selectJenisKategori,
    isRefund
  ]);

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }
  async function showDetailPenjualan(id) {
    setOpenLoading(true);
    await http
      .get(`penjualan/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailPenjualan(res.data.data);
        setIsOpen(true);
      });
    setOpenLoading(false);
  }

  useEffect(() => {
    async function getCabangSelect() {
      await http
        .get(`cabang?is_toko=1`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setSelectCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getCabangSelect();
  }, [navigate]);

  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, []);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    // console.log('date::: ', date);
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  DinamicTitle('Transaksi Penjualan || Komaladewi');

  return (
    <Layouts
      title={'Transaksi Penjualan'}
      compFilter={
        <div className="flex items-center gap-2">
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              onClick={() => setOpenCalender(!openCalender)}
              className="bg-amber-500 hover:bg-amber-600 dark:bg-amber-600 dark:hover:bg-amber-700 transition flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md cursor-pointer shadow-sm"
              title="Filter Tanggal"
            >
              <IconCalendar className="text-white w-5 h-5" />
            </div>
            <div tabIndex={0} className={`dropdown-content -left-20 sm:-left-40 mt-1 z-50 p-2 shadow-lg rounded-md bg-white dark:bg-slate-800 border dark:border-slate-700`}>
              <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} className="dark:text-slate-800" />
            </div>
          </div>
          <div
            onClick={() => window.location.reload()}
            className="bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600 transition flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md cursor-pointer shadow-sm"
            title="Refresh Halaman"
          >
            <IconReload className="text-white w-5 h-5" />
          </div>
          <div className="flex justify-end ml-1">
            <Input
              className="input h-[2.5rem] border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
              type="text"
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              placeholder="Cari Faktur / Kode"
            />
          </div>
        </div>
      }
    >
      <div className="mt-4 md:mt-0">
        <div className="flex items-center justify-between overflow-x-auto pb-0 scrollbar-none">
          <div className="flex items-center bg-white dark:bg-slate-900 justify-center md:justify-start w-full">
            <div>
              <div className="flex gap-2 p-2">
                <select
                  onChange={(e) => setIdCabang(e.target.value)}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Semua Etalase</option>
                  {selectCabang.map((cb) => (
                    <option value={cb.id} key={cb.id}>
                      {cb.nama_cabang}
                    </option>
                  ))}
                </select>
                <select
                  value={selectedKategori}
                  onChange={handleKategoriChange}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Semua Kategori</option>
                  {kategori.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nama_kategori}
                    </option>
                  ))}
                </select>

                {selectedKategori && (
                  <select
                    onChange={handleJenisKategoriChange}
                    value={selectJenisKategori}
                    className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                  >
                    <option value="">Jenis Kategori</option>
                    {kategori
                      .find((kt) => kt.id == selectedKategori)
                      ?.jenis_kategori.map((jk) => (
                        <option key={jk.id} value={jk.id}>
                          {jk.nama_jenis}
                        </option>
                      ))}
                  </select>
                )}

                <select
                  onChange={(e) => setKaratOptionId(e.target.value)}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Karat</option>
                  {karatOption.map((kto) => (
                    <option key={kto} value={kto}>
                      {kto}
                    </option>
                  ))}
                </select>

                <div className="flex gap-1 items-center ml-1">
                  <Input
                    onChange={(e) => setFilterBerat(e.target.value)}
                    placeholder="Cari Berat"
                    className="h-[2.5rem] w-32 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
                  />
                  <button onClick={filterBeratBarang} className="bg-amber-500 hover:bg-amber-600 dark:bg-amber-600 dark:hover:bg-amber-700 flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm">
                    <IconSearch className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => window.location.reload()}
                    className="bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600 flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm"
                  >
                    <IconReload className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dark:border-slate-700/60 pt-2">
          <DetailBarangPenjualan
            label={'Penjualan'}
            checkBerat={checkBerat}
            closeModal={closeModal}
            detailPenjualan={detailPenjualan}
            isOpen={isOpen}
          />
          {openLoading ? (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
              <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
            </div>
          ) : (
            ''
          )}
          <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 flex gap-2">
            <div className="inline-block min-w-full shadow-sm sm:rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
              <div className="relative overflow-x-auto scrollbar-thin">
                <table className="min-w-full leading-normal">
                  <thead className="sticky top-0 z-10">
                    <tr className="bg-gradient-to-r from-amber-50 to-amber-100/70 dark:from-slate-800 dark:to-slate-800/70 border-b border-amber-200/50 dark:border-slate-700">
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        No
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Kode Barang
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Nama Barang
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Berat | Karat
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Harga
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Rata | Gram
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Kasir
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap">
                        Tanggal
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <tr className="flex  items-center justify-center">
                          <td className="w-5 h-5  rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent mt-4"></td>
                          <td className=" font-semibold px-2 py-4 rounded-md text-slate-500 dark:text-slate-400">Memuat data....</td>
                        </tr>
                      </>
                    ) : (
                      <>
                        {trxPenjualan.map((trx, i) => (
                          <tr
                            key={trx.id}
                            onClick={() => showDetailPenjualan(trx.id)}
                            className="hover:bg-amber-50 dark:hover:bg-slate-800/80 bg-white dark:bg-slate-900 cursor-pointer transition-colors border-b border-slate-100 dark:border-slate-700/50"
                          >
                            <td className="px-5 py-3 text-sm">
                              <p className="text-slate-900 dark:text-slate-300 whitespace-no-wrap font-medium">{startIndex + i + 1}.</p>
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm">
                              <p className="text-amber-700 dark:text-amber-500 font-medium whitespace-no-wrap">{trx.item.kode_item}</p>
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">
                                {trx.item?.jenis_kategori?.nama_jenis}{' '}
                                {trx.is_refund === true && (
                                  <span className="text-red-500 dark:text-red-400 text-xs font-medium ml-1.5 px-1.5 py-0.5 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-900/50">dikembalikan</span>
                                )}
                              </p>
                            </td>

                            <td className="px-5 py-3 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">
                                <span className="font-medium">{trx.item?.berat} gr</span> <span className="text-slate-400 dark:text-slate-500">| {trx.item?.karat} krt</span>
                              </p>
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300 font-medium">
                              Rp {numberWithCommas(trx.total_harga == undefined ? '0' : trx.total_harga)}
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300">
                              Rp{' '}
                              {numberWithCommas(
                                trx.total_harga == undefined ? '0' : Math.round(trx.total_harga / trx.item?.berat),
                              )}{' '}
                              <span className="text-slate-400 dark:text-slate-500">/ gr</span>
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">{trx.user?.name}</p>
                            </td>
                            <td className="px-5 py-3 whitespace-nowrap text-sm">
                              <p className="text-slate-800 dark:text-slate-300 whitespace-no-wrap">{trx.created_at}</p>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="bg-slate-50 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 py-3 transition-colors">
                <div className="flex justify-end w-full px-5">
                  <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 sm:flex">
                    <span className="block text-slate-700 dark:text-slate-300 font-medium">
                      Page {currentPage} of {lastPage}{' '}
                    </span>
                    <div className="space-x-1">
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        title="previous"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronLeft className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        title="next"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default TrxPenjualan;
